module.exports = __webpack_public_path__ + "media/images/partner-9-0cdb7a3b13d6d8df19780045456c982d.png";